<template>
  <div class="border-b border-gray-200 pb-5">
    <h3 class="text-base font-semibold text-gray-900">Job Postings</h3>
  </div>
</template>

<script>
export default {
  name: "AboutPage",
};
</script>
